<template>
  <SelectSingleInput
    v-model="model"
    :items="items"
    item-text="inspQtyStdText"
    item-value="inspQtyStdCd"
    :label="label"
    :disabled="disabledComputed"
    :loading="loading"
    :required="required"
    @input="onInput"
  />
</template>

<script>
import SelectSingleInput from '@/components/atoms/base/select/SelectSingleInput'
import { API } from '@/plugins/api'
import APIUtils from '@/mixin/api-utils.js'
import Message from '@/mixin/message-utils.js'

export default {
  name: 'PartInspQtyStdInput',

  mixins: [APIUtils, Message],

  components: { SelectSingleInput },

  props: {
    value: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
      default: function () {
        return this.$t('ELE0286')
      },
    },
    disabled: {
      type: Boolean,
      default: false,
      required: false,
    },
    required: {
      type: Boolean,
      default: false,
      required: false,
    },
    validOnly: {
      type: Boolean,
      required: false,
      default: false,
    },
    partInspTimingCd: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      items: [],
      loading: false,
    }
  },

  computed: {
    model: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value ? value : '')
      },
    },
    disabledComputed() {
      return this.disabled || this.items.length == 0
    },
  },

  watch: {
    partInspTimingCd: {
      async handler(value) {
        await this.setPartInspQty(value)
      },
      immediate: true,
    },
  },

  methods: {
    onInput(value) {
      const select = this.items.find((v) => v.inspQtyStdCd == value)
      let reqInspBasicQty = false
      if (select != undefined) {
        reqInspBasicQty = select.reqInspBasicQty
      }
      this.$emit('change', value, reqInspBasicQty)
    },
    async setPartInspQty(partInspTimingCd) {
      this.loading = true
      this.items = []

      try {
        if (partInspTimingCd) {
          let params = {}
          params.partInspTimingCd = partInspTimingCd
          if (this.validOnly) {
            params.validOnly = true
          }

          const elements = await API.get('/master/inspQtyStds', params)
          elements.forEach((element) => {
            element['inspQtyStdText'] = `${element['inspQtyStdCd']} : ${element['inspQtyStdName']}`
            this.items.push(element)
          })
          this.onInput(this.model)
        }
      } catch (error) {
        this.setErrorMessage(this.resolveErrorMessage(error, this.$t('MSG0002', { p0: this.$t('ELE0286') })))
      } finally {
        this.loading = false
      }
    },
  },
}
</script>
